import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useContext, useEffect } from "react";
import Alert from ".";
import { getIsLoggedIn, getIsOnpremise, getIsPatientDeletionEnabled } from "../../utils";
import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
import { get, isEmpty } from "lodash";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { PatientsContext } from "../Patients/PatientsContext";
import { LicenseContext } from "../LicenseManager/LicenseContext";
import { useTranslation } from "react-i18next";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
function Warning() {
  var _useContext = useContext(PatientsContext),
    wsData = _useContext.wsData;
  var _useContext2 = useContext(LicenseContext),
    stickyAlert = _useContext2.stickyAlert,
    alertDetails = _useContext2.alertDetails;
  var isOnpremise = getIsOnpremise();
  var isPatientDeletionEnabled = getIsPatientDeletionEnabled();
  var isLoggedin = getIsLoggedIn();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useStoreState = useStoreState(Store, function (store) {
      return {
        authData: store.userInfo,
        isDiskSpaceWarning: store.isDiskSpaceWarning,
        patientsFileDeletionStatus: store.patientsFileDeletionStatus
      };
    }),
    authData = _useStoreState.authData,
    isDiskSpaceWarning = _useStoreState.isDiskSpaceWarning,
    patientsFileDeletionStatus = _useStoreState.patientsFileDeletionStatus;
  useEffect(function () {
    if (wsData && (wsData === null || wsData === void 0 ? void 0 : wsData.action) == "license_activation") {
      Store.update(function (s) {
        var _wsData$content;
        s.userInfo = _objectSpread(_objectSpread({}, authData), {}, {
          trial_scans_remaining: wsData === null || wsData === void 0 || (_wsData$content = wsData.content) === null || _wsData$content === void 0 ? void 0 : _wsData$content.trial_scans_remaining
        });
      });
    }
  }, [wsData]);
  var diskUsage = get(authData, ["disk_usage"], {});
  var trial_scans_remaining = get(authData, ["trial_scans_remaining"], 0);
  var isDeletionStatus = function isDeletionStatus(status) {
    return ["in_process", "started"].includes(status);
  };
  var isFilesDeletionOn = isDeletionStatus(diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.file_deletion) || isDeletionStatus(patientsFileDeletionStatus);
  var onClickDiskAlert = function onClickDiskAlert(type) {
    // add code to track event on mixpanel, add event name as DISK_SPACE_ALERT_CLICKED and type in properties
    trackEvent(MIXPANEL_EVENTS.DISK_SPACE_ALERT_CLICKED, {
      type: type
    });
    Store.update(function (s) {
      s.isSettingsOpen = true;
      s.selectedSetting = "disk-management";
    });
  };
  var onClickLicenseAlert = function onClickLicenseAlert(type) {
    trackEvent(MIXPANEL_EVENTS.LICENSE_ALERT_CLICKED, {
      type: type
    });
    Store.update(function (s) {
      s.isSettingsOpen = true;
      s.selectedSetting = "license";
    });
  };
  var diskAlertContent = function diskAlertContent() {
    if (!isOnpremise || !isPatientDeletionEnabled) return null;
    if (isFilesDeletionOn && patientsFileDeletionStatus !== "completed") {
      return /*#__PURE__*/React.createElement(Alert, {
        className: "bg-red-800",
        messageKey: "disk_management.deletion_message",
        showProgress: true
      });
    }
    if ((diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.used_percent) > 99) {
      return /*#__PURE__*/React.createElement(Alert, {
        className: "bg-red-600",
        icon: faTriangleExclamation,
        messageKey: "disk_management.popup_message_critical",
        onClick: function onClick() {
          return onClickDiskAlert("critical");
        }
      });
    }
    if (isDiskSpaceWarning) {
      return /*#__PURE__*/React.createElement(Alert, {
        className: "bg-yellow-400 text-gray-900",
        icon: faTriangleExclamation,
        onClick: function onClick() {
          return onClickDiskAlert("warning");
        },
        messageKey: "disk_management.popup_message_warning",
        dynamicMessagePart: {
          usedPercent: diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.used_percent,
          totalDisk: diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.total
        }
      });
    }
    return null;
  };
  var licenseExpiredContent = function licenseExpiredContent() {
    if (isLoggedin && isOnpremise && !isEmpty(alertDetails) && !(alertDetails !== null && alertDetails !== void 0 && alertDetails.remainingPercentage)) {
      return /*#__PURE__*/React.createElement(Alert, {
        className: "bg-red-600 cursor-pointer",
        icon: faTriangleExclamation,
        messageKey: "license_expire.popup_message",
        onClick: function onClick() {
          return onClickLicenseAlert("expired");
        }
      });
    }
    return null;
  };
  var licenseAlertContent = function licenseAlertContent() {
    if (!isLoggedin || !isOnpremise || isOnpremise && isEmpty(stickyAlert)) return null;
    var _ref = stickyAlert || {},
      license_type = _ref.license_type,
      total_days_remaining = _ref.total_days_remaining,
      total_scans_remaining = _ref.total_scans_remaining;
    var remaining = license_type === "TIME" ? "".concat(total_days_remaining) : "".concat(total_scans_remaining);
    var message = t("license_manager.license_expire_after", {
      remaining: remaining
    });
    if (license_type === "TIME") {
      message = t("license_manager.license_expire_in", {
        remaining: remaining
      });
    }
    return /*#__PURE__*/React.createElement(Alert, {
      className: "bg-yellow-400 text-gray-800 cursor-pointer",
      icon: faTriangleExclamation,
      messageKey: message,
      onClick: function onClick() {
        return onClickLicenseAlert("regular");
      }
    });
  };
  var trialLicenseAlertContent = function trialLicenseAlertContent() {
    var isTrialActive = !!trial_scans_remaining && trial_scans_remaining > 0;
    if (!isTrialActive || !isLoggedin) {
      return null;
    }
    var message = t("license_manager.trial_license_remaining").replace("[1]", "".concat(trial_scans_remaining));
    return /*#__PURE__*/React.createElement(Alert, {
      className: "bg-yellow-800 cursor-pointer",
      messageKey: message,
      onClick: function onClick() {
        return onClickLicenseAlert("trial");
      }
    });
  };
  return diskAlertContent() || licenseExpiredContent() || licenseAlertContent() || trialLicenseAlertContent();
}
export default Warning;